import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatPrice, formatDate } from "../../lib/api";
import { Card } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Search, Eye } from "lucide-react";

const ORDER_STATES = ["Nuovo", "Pagato", "In preparazione", "Spedito", "Consegnato", "Annullato"];
const PAY_STATES = ["In attesa", "Pagato", "Pagamento fallito", "Rimborsato"];
const OC = { "Nuovo": "bg-sky-50 text-sky-700", "Pagato": "bg-emerald-50 text-emerald-700", "In preparazione": "bg-amber-50 text-amber-700", "Spedito": "bg-violet-50 text-violet-700", "Consegnato": "bg-emerald-100 text-emerald-800", "Annullato": "bg-rose-50 text-rose-700" };

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [os, setOs] = useState("");
  const [ps, setPs] = useState("");
  const navigate = useNavigate();

  const load = useCallback(() => {
    const p = {};
    if (search) p.search = search;
    if (os) p.order_status = os;
    if (ps) p.payment_status = ps;
    api.get("/admin/orders", { params: p }).then(({ data }) => setOrders(data));
  }, [search, os, ps]);

  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-extrabold font-display text-slate-900">Gestione Ordini</h1>
      <div className="mt-6 flex flex-col md:flex-row gap-3">
        <div className="relative flex-1 max-w-md"><Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" /><Input placeholder="Cerca per numero, nome, email..." value={search} onChange={(e) => setSearch(e.target.value)} className="pl-10 rounded-full" data-testid="order-search" /></div>
        <select value={os} onChange={(e) => setOs(e.target.value)} className="h-10 rounded-full border border-input bg-background px-4 text-sm" data-testid="filter-order-status"><option value="">Tutti gli stati</option>{ORDER_STATES.map((s) => <option key={s} value={s}>{s}</option>)}</select>
        <select value={ps} onChange={(e) => setPs(e.target.value)} className="h-10 rounded-full border border-input bg-background px-4 text-sm" data-testid="filter-pay-status"><option value="">Tutti i pagamenti</option>{PAY_STATES.map((s) => <option key={s} value={s}>{s}</option>)}</select>
      </div>

      <Card className="mt-6 rounded-2xl border-slate-200 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Numero</TableHead><TableHead>Data</TableHead><TableHead>Cliente</TableHead><TableHead className="text-right">Totale</TableHead><TableHead>Pagamento</TableHead><TableHead>Stato</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {orders.map((o) => (
              <TableRow key={o.id} className="cursor-pointer hover:bg-slate-50" onClick={() => navigate(`/admin/ordini/${o.id}`)} data-testid={`admin-order-${o.id}`}>
                <TableCell className="font-medium">{o.order_number}</TableCell>
                <TableCell className="text-slate-500 text-sm">{formatDate(o.created_at)}</TableCell>
                <TableCell>{o.customer.nome} {o.customer.cognome}</TableCell>
                <TableCell className="text-right font-medium">{formatPrice(o.total)}</TableCell>
                <TableCell><span className={o.payment_status === "Pagato" ? "text-emerald-600 text-sm font-medium" : "text-amber-600 text-sm"}>{o.payment_status}</span></TableCell>
                <TableCell><span className={`text-xs font-medium rounded-full px-2.5 py-1 ${OC[o.order_status]}`}>{o.order_status}</span></TableCell>
                <TableCell><Eye className="w-4 h-4 text-slate-400" /></TableCell>
              </TableRow>
            ))}
            {!orders.length && <TableRow><TableCell colSpan={7} className="text-center text-slate-400 py-8">Nessun ordine.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
